import React from 'react';
import QuickCreateProjectModal from '../browse-talent/QuickCreateProjectModal';

/**
 * QuickTalentPoolReqModal - Wrapper for talent pool req creation
 * Creates a req and invites all talent users in the pool
 */
const QuickTalentPoolReqModal = ({talentPool, onSuccess, onClose}) => {
    return (
        <QuickCreateProjectModal
            type="talent-pool"
            data={talentPool}
            searchFilters={{}}
            onSuccess={onSuccess}
            onClose={onClose}
        />
    );
};

export default QuickTalentPoolReqModal;
